<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">班會紀錄表及統計表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <!--<div class="col-12">
                <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
            </div>-->
            <div class="col-12">
                <form-input v-model="vm.TeacherNo" id="TeacherNo" label="教師編號" type="text" required></form-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'classrecordDetail',
        api: '/api/classrecord/'
    });
</script>

<style>
</style>